import React from "react";
import "./assets/Loading.css";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-ring"></div>
    </div>
  );
};

export default Loading;
